module.exports = __webpack_public_path__ + "a-b06f6f35d8aeaa5d32c4206cb50990c9.png";